import React from 'react'
import {Button} from 'semantic-ui-react'

const TakeThePledgeButton = () =>
<Button className="massive ui button">
TAKE THE PLEDGE
</Button>

export default TakeThePledgeButton;
